<template>
  <div class="content" :class="orderDetail.deal_time>0&&onDehalf==0||orderDetail.ask_type==1?'w-64':onDehalf== 1?'w-94':''">
    <div class="OrderHousing">
    <!--新版·多晚入住模式-->
    <template v-if="orderDetail.room_need_arr&&orderDetail.room_need_arr.mode==1">
      <div class="OrderHousing-title" v-if="onDehalf==0">用房需求<span v-if="orderDetail.room_need_arr.num>0">(共{{orderDetail.room_need_arr.num}}间)</span></div>
        <el-table
            :data="tableList"
            border
            :span-method="objectSpanMethod"
            style="width:100%"
            class="mb-4"
            v-if="tableList&&tableList.length>0"
            max-height="480"
        >
        <el-table-column label="用房需求">
          <el-table-column v-for="(item,index) in demand" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" align="center" >
                <template slot-scope="scope">
                        <!--类型-->
                        <div  v-if="item.pattern==='type'" :class="{'red':measuredvalue({value:'room_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">
                          <div class="tiemAdd">
                            <span class="mark-add mardk-left" v-if="measuredvalue({value:'room_need_arr',time:scope.row.date,pattern:'add',index:scope.$index})">新增</span>
                            <span>{{ scope.row[item.prop]| formatVar('roomStyle')}}</span>
                          </div>
                        </div>
                        <!--时间-->
                        <div  v-if="item.pattern==='time'" :class="{'red':measuredvalue({value:'room_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">
                          <div class="tiemAdd">
                            <span class="mark-add" v-if="measuredvalue({value:'room_need_arr',time:scope.row.date,pattern:'add',index:scope.$index})">新增</span>
                            <span> {{ scope.row[item.prop]| formatTimestamp(2)}}</span>
                          </div>
                        </div>
                        <!--数量-->
                        <div  v-else-if="item.pattern==='num'" :class="{'red':measuredvalue({value:'room_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">{{ scope.row[item.prop]}}间</div>
                </template>
          </el-table-column>
        </el-table-column>
        <!--酒店成交报价-->
        <el-table-column label="酒店报价" v-if="orderDetail.deal_time>0||modify||orderDetail.status==5">
          <el-table-column v-for="item in hotelDemand" :key="item.name" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" align="center" >
                <template slot-scope="scope">
                        <!--房型-->
                        <div  :class="scope.row.offer_id!=0&&'text-blue'" @click="showRoomImgs(scope.row.offer_id,'room')" v-if="item.pattern==='title'">
                          {{ scope.row[item.prop]}}
                        </div>
                        <!--单价-->
                        <div  v-else-if="item.pattern==='money'" :class="{'red':measuredvalue({value:'room_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">{{ scope.row[item.prop]}}元/晚/间</div>
                        <!--早餐-->
                        <div  v-else-if="item.pattern==='breakfast'" :class="{'red':measuredvalue({value:'room_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">
                          {{ scope.row[item.prop]||orderDetail.breakfast_type}}</div>
                </template>
          </el-table-column>
        </el-table-column>
        </el-table>
    </template>
    <!--旧版·普通入住模式-->
    <template v-else-if="orderDetail.room_need_arr&&orderDetail.room_need_arr.mode==0">
        <div class="OrderHousing-title">用房需求<span v-if="orderDetail.room_need_arr.num>0">(共{{orderDetail.room_need_arr.num}}间)</span></div>
        <el-table
            :data="orderDetail.room_need_arr.list"
            border  
            class="mb-4"
            style="width:100%"
            :header-cell-style="{background:'#f2f7fe'}"
        >
        <el-table-column v-for="(item,index) in proptitle" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center" align="center">
            <!-- 自定义表头 -->
            <template slot-scope="scope">
                    <!--时间-->
                    <div  v-if="item.pattern==='type'">{{ scope.row[item.prop]| formatVar('roomStyle')}}</div>
                    <!--其他-->
                    <div  v-else>{{ scope.row[item.prop]}}间</div>
                    
            </template>
        </el-table-column>
        <el-table-column v-for="item in hotelDemand" :key="item.name" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" align="center" >
              <template slot-scope="scope">
                      <!--房型-->
                      <div  :class="scope.row.offer_id!=0&&'text-blue'" @click="showRoomImgs(scope.row.offer_id,'room')" v-if="item.pattern==='title'">
                        {{ scope.row[item.prop]}}
                      </div>
                      <!--单价-->
                      <div  v-else-if="item.pattern==='money'">{{ scope.row[item.prop]}}元/晚/间</div>
                      <!--早餐-->
                      <div  v-else-if="item.pattern==='breakfast'">{{ scope.row[item.prop]||orderDetail.breakfast_type}}</div>
              </template>
        </el-table-column>
        </el-table>
    </template>
    <!--优惠房-->
    <template v-if="discount_needList.length>0">
        <el-table
            :data="discount_needList"
            border
            :span-method="objectSpanMethodDiscount"
            style="width:100%"
            class="mb-4"
            v-if="discount_needList&&discount_needList.length>0"
            max-height="480"
        >
        <el-table-column label="优惠房">
          <el-table-column v-for="(item,index) in demand" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" align="center" >
                <template slot-scope="scope">
                        <!--类型-->
                        <div  v-if="item.pattern==='type'" :class="{'red':measuredvalue({value:'discount_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">
                          <div class="tiemAdd">
                            <span class="mark-add mardk-left" v-if="measuredvalue({value:'discount_need_arr',time:scope.row.date,pattern:'add',index:scope.$index})">新增</span>
                            <span>{{ scope.row[item.prop]| formatVar('roomStyle')}}</span>
                          </div>
                        </div>
                        <!--时间-->
                        <div  v-if="item.pattern==='time'">
                          <div class="tiemAdd">
                            <span class="mark-add" v-if="measuredvalue({value:'discount_need_arr',time:scope.row.date,pattern:'add',index:scope.$index})">新增</span>
                            <span> {{ scope.row[item.prop]| formatTimestamp(2)}}</span>
                          </div>
                        </div>
                        <!--数量-->
                        <div  v-else-if="item.pattern==='num'" :class="{'red':measuredvalue({value:'discount_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">{{ scope.row[item.prop]}}间</div>
                </template>
          </el-table-column>
          <el-table-column v-for="item in hotelDemand" :key="item.name" :prop="item.prop" :label="item.name=='单价'?'优惠单价':item.name" :width="item.width" :min-width="item.minWidth" align="center" >
                <template slot-scope="scope">
                        <!--房型-->
                        <div  :class="scope.row.offer_id!=0&&'text-blue'" @click="showRoomImgs(scope.row.offer_id,'room')" v-if="item.pattern==='title'">
                          {{ scope.row[item.prop]}}
                        </div>
                        <!--单价-->
                        <div  v-else-if="item.pattern==='money'" :class="{'red':measuredvalue({value:'discount_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">{{ scope.row[item.prop]}}元/晚/间</div>
                        <!--早餐-->
                        <div  v-else-if="item.pattern==='breakfast'" :class="{'red':measuredvalue({value:'discount_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">
                          {{ scope.row[item.prop]}}</div>
                </template>
          </el-table-column>
        </el-table-column>
        </el-table>
    </template>
    <div class="OrderHousing-title" v-if="orderDetail.meeting_need_arr&&orderDetail.meeting_need_arr.list&&onDehalf==0">会议需求</div>
        <!--新版·会议需求-->
        <el-table
            :data="orderDetail.meeting_need_arr.list"
            border
            style="width:100%"
            v-if="orderDetail.meeting_need_arr&&orderDetail.meeting_need_arr.list"
        >
        <el-table-column label="会议需求">
          <el-table-column v-for="(item,index) in meetingDemand" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" align="center" >
                <template slot-scope="scope">
                        <!--时间-->
                        <div  v-if="item.pattern==='time'">
                          <div class="tiemAdd">
                            <span class="mark-add mardk-left" v-if="measuredvalue({value:'meeting_need_arr',time:scope.row.date,pattern:'add',index:scope.$index})">新增</span>
                            <span>{{ scope.row[item.prop]| formatTimestamp(2)}}</span>
                          </div>
                        </div>
                        <!--时段-->
                        <div  v-if="item.pattern==='timeslot'" :class="{'red':measuredvalue({value:'meeting_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">{{ scope.row[item.prop]| formatVar('TimeSlots')}}</div>
                        <!--布局-->
                        <div  v-else-if="item.pattern==='type'" :class="{'red':measuredvalue({value:'meeting_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">{{ scope.row[item.prop] | formatVar('LayoutTypes')}}</div>
                        <!--出席人数-->
                        <div  v-else-if="item.pattern==='num'" :class="{'red':measuredvalue({value:'meeting_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">{{ scope.row[item.prop] }}人</div>
                        <!--要求面积-->
                        <div  v-else-if="item.pattern==='area'" :class="{'red':measuredvalue({value:'meeting_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">{{ scope.row[item.prop]}}㎡</div>
                </template>
          </el-table-column>
        </el-table-column>
        <!--酒店成交报价-->
        <el-table-column label="酒店报价" v-if="orderDetail.deal_time>0||modify">
          <el-table-column v-for="(item,index) in hotelMeetingDemand" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" align="center" >
                <template slot-scope="scope">
                        <!--房型-->
                        <div  :class="scope.row.offer_id!=0&&'text-blue'" @click="showRoomImgs(scope.row.offer_id,'room')" v-if="item.pattern==='offer_title'">
                          {{ scope.row[item.prop]}}
                        </div>
                        <!--单价-->
                        <div  v-else-if="item.pattern==='offer_price'">{{ scope.row[item.prop]}}元</div>
                </template>
          </el-table-column>
        </el-table-column>
        </el-table>
        <!--附加需求-->
        <el-table
            :data="orderDetail.add_need_arr.list"
            border
            class="mt-4"
            style="width:100%"
            v-if="orderDetail.add_need_arr&&orderDetail.add_need_arr.list"
        >
        <el-table-column label="附加需求">
          <el-table-column v-for="(item,index) in addDemand" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" align="center" >
                <template slot-scope="scope">
                        <div  v-if="item.pattern==='add_title'">
                          <div class="tiemAdd">
                            <span class="mark-add mardk-left" v-if="measuredvalue({value:'add_need_arr',time:scope.row.date,pattern:'add',index:scope.$index})">新增</span>
                            <span>{{ scope.row[item.prop] }}</span>
                          </div>
                        </div>
                        <!--要求面积-->
                        <div  v-else-if="item.pattern==='add_price'" :class="{'red':measuredvalue({value:'add_need_arr',time:scope.row.date,pattern:item.prop,index:scope.$index})}">{{ scope.row[item.prop]}}元</div>
                </template>
          </el-table-column>
        </el-table-column>
        </el-table>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions,mapMutations } from 'vuex'
export default {
  name: 'OrderHousing',
  components: {},
  props: {
    orderDetail: {
      type: Object,
      default: () => {}
    },
    quotationList: {
      type: Object,
      default: () => {}
    },
    //是否是代收款弹窗
    onDehalf: {
      type: Number,
      default: 0
    },
    //是否是修改用房需求
    modify: {
      type: Boolean,
      default: false
    },
    //修改用房需求差异数组
    differenceArray: {},
  },
  data() {
    return {
        //用房需求信息
        proptitle:[
            {name:'房间类型',prop:'type',minWidth:100,pattern:'type',center:true},  
            {name:'间数',prop:'room_num',minWidth:100,center:true},
        ],
        propertyInfo:[],
        MeetingType:['开会日期','时段','布局','出席人数','要求面积'],
        MeetingInfo:[],
        //用房需求信息
        demand:[
          {name:'入住日期',prop:'date',minWidth:150,pattern:'time',center:true},
          {name:'房间类型',prop:'type',Width:100,pattern:'type',center:true},
          {name:'房间数量',prop:'room_num',pattern:'num',Width:150,center:true},
        ],
        //酒店用房报价需求
        hotelDemand:[
          {name:'房型',prop:'offer_title',minWidth:200,pattern:'title',center:true},
          {name:'单价',prop:'offer_price',Width:100,pattern:'money',center:true},
          {name:'早餐',prop:'breakfast',Width:150,pattern:'breakfast',center:true},
        ],
        //会议需求信息
        meetingDemand:[
          {name:'开会日期',prop:'date',minWidth:150,pattern:'time',center:true},
          {name:'时段',prop:'timeslot',minWidth:100,pattern:'timeslot',center:true},
          {name:'布局',prop:'type',minWidth:80,pattern:'type',center:true},
          {name:'出席人数',prop:'num',minWidth:80,pattern:'num',center:true},
          {name:'要求面积',prop:'area',minWidth:80,pattern:'area',center:true},
        ],
        //会议报价信息
         hotelMeetingDemand:[
          {name:'会议室名称',prop:'offer_title',minWidth:200,pattern:'offer_title',center:true},
          {name:'价格',prop:'offer_price',minWidth:100,pattern:'offer_price',center:true},
        ],
        //附加需求信息
        addDemand:[
          {name:'名称',prop:'add_title',minWidth:200,pattern:'add_title',center:true},
          {name:'价格',prop:'add_price',minWidth:100,pattern:'add_price',center:true},
        ],
        tableList: [],
        spanArr: [], // 合并行数缓存
        pos: 0,
        //优惠房
        discount_needList:[],
        discount_needspanArr:[],
        discount_needpos: 0,

    };
  },
  computed: {
     ...mapState(['RoomMeetDetail']),
  },
  watch: {
      orderDetail: {
        handler(newVal,oldVal) {
          console.log(newVal);
         if(newVal.room_need_arr&&newVal.room_need_arr.mode==1){
            this.formatTableData(newVal.room_need_arr.list,'1');
            this.formatTableData(newVal.discount_need_arr.list,'2');
         }
        },
        deep: true,
        immediate: true
      }
  },
  created() {},
  mounted() {
  },
  methods: {
    ...mapActions(['getRoomDetail','getMeetDetail']),
    //对比差异值
    measuredvalue(res){
      const arr = [];
      let differenceArray=this.differenceArray;
      if(!differenceArray)return false;
      //当前数组
      let currentArr=differenceArray[res.value].list;
      console.log(currentArr,res.index);
      //房型转换成对应数组
      if(res.value=='room_need_arr'||res.value=='discount_need_arr'){
        if(currentArr&&currentArr.length>0){}else{return};
          currentArr.forEach(item => {
            const list = item.offer_info?item.offer_info:item.value.offer_info;
            if(list.type=='add'){
              arr.push({
                type:'add',
              })
              return false;
            }
            list.forEach(offer => {
              arr.push({
                date: item.date||item.value.date,
                dateStr: this.formatDate(item.date||item.value.date),
                ...offer
              })
            })
        });
      }else{
        arr.push(...currentArr);
      }
      if(!arr)return false;
      if(arr[res.index].type=='add'){
        if(res.pattern=='add'){
            return true;
        }else{
            return false;
        }
      }
      if(res.pattern=='add'){
        return false;
      }
      if((arr[res.index][res.pattern].type)) return true;
      return false;
    },
    // 时间戳转日期
    formatDate(t) {
      const d = new Date(t * 1000)
      return `${d.getFullYear()}-${(d.getMonth()+1+'').padStart(2,'0')}-${(d.getDate()+'').padStart(2,'0')}`
    },
    // 数组扁平化：日期拆分多条房型行
    formatTableData(newVal,type) {
      const arr = [];
      if(newVal&&newVal.length>0){}else{return};
        newVal.forEach(item => {
          item.offer_info.forEach(offer => {
            arr.push({
              date: item.date,
              dateStr: this.formatDate(item.date),
              ...offer
            })
          })
      });
      if(type=='1'){
        this.tableList = arr;
      }else{
        this.discount_needList = arr;
      }
      
      this.getSpanArr(arr,type)
    },
    // 计算日期列合并跨度
    getSpanArr(arr,type) {
      let spanArr = []
      let pos = 0
      arr.forEach((item, index) => {
        if (index === 0) {
          spanArr.push(1)
          pos = 0
        } else {
          if (item.date === this.tableList[index - 1].date) {
            spanArr[pos] += 1
            spanArr.push(0)
          } else {
            spanArr.push(1)
            pos = index
          }
        }
      })
      if(type=='1'){
        this.spanArr = spanArr;
        this.pos = pos;
      }else{
        this.discount_needspanArr = spanArr;
        this.discount_needpos = pos;
      }
    },
    // 合并单元格回调
    objectSpanMethod({ row, columnIndex, rowIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return { rowspan: _row, colspan: _col }
      }
    },
    // 合并单元格回调
    objectSpanMethodDiscount({ row, columnIndex, rowIndex }) {
      if (columnIndex === 0) {
        const _row = this.discount_needspanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return { rowspan: _row, colspan: _col }
      }
    },
    //展示房型、会议室图片
    async showRoomImgs(item,type) {
      if(item==0) return;
      let data = {
        type:3,
        id:item
      }
      switch (type) {
        case 'room':
          await this.getRoomDetail(data);
          break;
        case 'meet':
          await this.getMeetDetail(data);
          break;
      }
      if(this.RoomMeetDetail!=''){
        this._CarouselView({
          currentImg: 0,
          picArray: this.RoomMeetDetail.pic
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
    .content{
        width: 25%;
        background-color: #FFF;
        padding: 16px 2%;
        border-radius: 6px;
        height: max-content;
        min-height: 220px;
    }
    .w-64{
      width: 64%;
    }
    .w-94{
      width: 96%;
    }
    .travel-title,.housing-title,.OrderHousing-title{
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 26px;
        span{
          color: #666;
          font-weight: normal;
          font-size: 14px;
        }
    }
    .OrderHousing-list{
        display: flex;
        margin-top: 20px;
        li{
            width: 50%;
            text-align: center;
            border: 1px #eee solid;
            padding: 6px 10px;
            background-color: #f2f7fe;
        }
    }
    .OrderHousing-info{
        display: flex;
        li{
            width: 50%;
            border: 1px #eee solid ;
            padding: 6px 10px;
            text-align: center;
            color: #666;
        }
    }
    .text-blue{
      cursor: pointer;
    }
    .tiemAdd{
      position: relative;
    }
    .mark-add{
      background-color: red;
      color: #fff;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 50%;
      font-size: 12px;
      display: inline-block;
      position: absolute;
      top: 0;
      left: 10px;
    }
    .mardk-left{
      left:-2px;
    }
</style>
<style>
  .content .el-table__row:hover > td {
    background-color: transparent !important;
  }
</style>